@if (data?.title) {
<h2 mat-dialog-title *ngIf="data?.title">{{ data?.title }}</h2>
}

<mat-dialog-content>{{ data.content }}</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton [mat-dialog-close]="false">Non</button>
  <button matButton [mat-dialog-close]="true">Oui</button>
</mat-dialog-actions>
